export default __webpack_public_path__ + "static/media/buyItForMe.edaf1223.svg";